import { carpFish, carpFishDefs, paifang, paifangDefs } from '../carp';
import { body, coverBg, edge, fade, mix, n, rng, shade, shadowInk, tint, vgrad, type ArtPal } from './kit';

/**
 * Dragon Gate (鲤鱼跃龙门): a waterfall between two cliffs, the Dragon Gate on top — a Chinese paifang (牌坊), not a
 * Japanese torii — and a carp leaping up the fall.
 * Placeholder art (no text) until the final graphics — see docs/art-prompts.md.
 */
export function carpCover(P: ArtPal, p: string): string {
  const cx = 440; // focus: the waterfall axis
  const top = P.dark ? mix(P.bg, P.sky, 0.1) : tint(P.sky, 0.9);
  const mid = P.dark ? mix(P.panel, P.teal, 0.08) : tint(P.teal, 0.92);
  const bg = coverBg(p, P, top, mid, P.bg, [cx, 170]);
  const water = P.dark ? mix(P.sky, P.teal, 0.35) : tint(P.sky, 0.25);
  const rock = P.dark ? mix(P.slate, P.panel, 0.2) : tint(P.slate, 0.55);

  // waterfall: from under the gate (y 118) down to the pool (y 330), slightly wider at the bottom
  const fall = `M${cx - 58} 118L${cx + 58} 118L${cx + 70} 330L${cx - 70} 330Z`;
  const r = rng(88);
  let streaks = '';
  for (let i = 0; i < 9; i++) {
    const x = cx - 50 + i * 12.5 + (r() - 0.5) * 4;
    const y0 = 124 + r() * 60;
    streaks += `<path d="M${n(x)} ${n(y0)}L${n(x + (x - cx) * 0.1)} ${n(y0 + 90 + r() * 90)}" stroke="#FFFFFF" stroke-opacity="${n(0.2 + r() * 0.25)}" stroke-width="${n(2 + r() * 2)}" stroke-linecap="round"/>`;
  }
  let drops = '';
  for (let i = 0; i < 10; i++) {
    const a = Math.PI * (1.05 + r() * 0.9);
    const d = 60 + r() * 50;
    drops += `<circle cx="${n(cx + Math.cos(a) * d * 1.4)}" cy="${n(326 + Math.sin(a) * d * 0.5)}" r="${n(2.5 + r() * 3.5)}" fill="#FFFFFF" fill-opacity="${n(0.45 + r() * 0.35)}"/>`;
  }

  // cliffs either side of the fall
  const cliffL = `M300 400L306 250Q316 180 350 150Q368 128 ${cx - 56} 116L${cx - 70} 330L${cx - 90} 400Z`;
  const cliffR = `M580 400L574 260Q566 190 536 156Q518 130 ${cx + 56} 116L${cx + 70} 330L${cx + 90} 400Z`;

  // the Dragon Gate: a Chinese paifang (three bays, four red pillars, upturned eaves), its 300 × 170 box scaled to 186 × 105
  const gateArt = `<g transform="translate(${cx - 93} 20) scale(.62)">${paifang(P, p)}</g>`;

  // carp leaping up the fall — rotated nose-up
  const carp = `<g transform="translate(${cx} 226) rotate(-62)">${carpFish(P, p)}</g>`;

  const defs =
    `<defs>${bg.defs}` +
    fade(`${p}sh`, shadowInk(P), P.dark ? 0.5 : 0.16) +
    vgrad(`${p}wf`, tint(water, 0.35), water, shade(water, 0.15)) +
    body(`${p}ck`, rock, 0.25, 0.4, 0.5, 1) +
    paifangDefs(P, p) +
    carpFishDefs(P, p) +
    fade(`${p}gl`, P.dark ? P.gold : '#FFFFFF', P.dark ? 0.35 : 0.7) +
    `</defs>`;

  return (
    defs +
    bg.body +
    `<ellipse cx="${cx}" cy="70" rx="150" ry="70" fill="url(#${p}gl)"/>` +
    `<path d="${cliffL}" fill="url(#${p}ck)" stroke="${edge(rock, P)}" stroke-width="2" stroke-linejoin="round"/>` +
    `<path d="${cliffR}" fill="url(#${p}ck)" stroke="${edge(rock, P)}" stroke-width="2" stroke-linejoin="round"/>` +
    `<path d="${fall}" fill="url(#${p}wf)"/>` +
    streaks +
    `<ellipse cx="${cx}" cy="340" rx="170" ry="30" fill="${water}" fill-opacity=".55"/>` +
    `<ellipse cx="${cx}" cy="334" rx="96" ry="14" fill="#FFFFFF" fill-opacity=".5"/>` +
    drops +
    gateArt +
    `<ellipse cx="${cx + 20}" cy="300" rx="46" ry="8" fill="url(#${p}sh)"/>` +
    carp
  );
}
